<template>
  <div class="py-16 bg-gray-50">
    <div class="container mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Products</h2>
        <p class="text-gray-600 max-w-2xl mx-auto">A comprehensive range of imaging products designed for your business
          needs</p>
      </div>

      <!-- 商品列表 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        <!-- 商品1：N809 -->
        <router-link :to="{ name: 'ProductDetail', params: { productId: product.id } }"
          class="product-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow group"
          v-for="product in productData" :key="product.id">
          <div class="relative overflow-hidden h-60">
            <img :src="product.imagesUrl[0]" alt="N809 Wax General Thermal Transfer Ribbon"
              class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
          </div>
          <div class="p-6">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">{{ product.name }}</h3>
            <p class="text-gray-600 mb-4 line-clamp-2">{{ product.application }}</p>
            <div class="flex justify-between items-center">
              <span class="text-primary font-bold"></span>
              <span class="inline-flex items-center text-primary font-medium hover:text-primary/80">Details<i
                  class="fa fa-arrow-right ml-2 text-sm"></i></span>
            </div>
          </div>
        </router-link>

      </div>

      <!-- 分页器组件 -->
      <Pagination :current-page="pageNum" :total="total" :page-size="pageSize" @page-change="handlePageChange" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Pagination from '@/components/Pagination.vue';
import { pageProduct } from '@/api/product'
// 分页逻辑
const pageNum = ref(1)
const productData = ref([])
const total = ref(0)
const pageSize = ref(6)
onMounted(() => {
  getPageProduct()
})
const getPageProduct = async () => {
  let res = await pageProduct({
    pubStatus: 2,
    pageNum: pageNum.value,
    pageSize: pageSize.value
  })
  productData.value = res.rows
  total.value = res.total
}
// 处理页码变更
const handlePageChange = (newPage) => {
  pageNum.value = newPage;
  getPageProduct()
};
</script>

<style scoped>
.product-card {
  transition: all 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
}

.text-primary {
  color: #3b82f6;
}
</style>